import { useMutation } from 'react-query';
import { userLogin } from './userLogin';

export const useLogin = () => {
  return useMutation(userLogin);
};
